const config = {
  tiUrl:
    window.REACT_TI_APP_API_URL ?? "https://titre-importationdev.portnet.ma",
  crcUrl: window.CRC_URL ?? "https://portail-crc-test.portnet.ma",
  cautionURL: window.CAUTION_URL ?? "https://caution-dev.portnet.ma",
  // wsUrl: window.WS_URL ?? "https://messagerie-dev.portnet.ma",
  authUrl: window.REACT_APP_AUTH_API_URL ?? "https://guauth-dev.portnet.ma",
  refProdUrl:
    window.REACT_APP_REFERENTIEL_PROD_API_URL ??
    "https://referentiel-api-v2.portnet.ma",
  refTestUrl:
    window.REACT_APP_REFERENTIEL_TEST_API_URL ??
    "https://referentiel-api-v2.portnet.ma",
  crossOrigin: window.REACT_APP_CROSS_ORIGIN_URL ?? "https://ms.portnet.ma",
  captchaSiteKey: window.CAPCTHA_SITE ?? "6LdBG8csAAAAAP9EfOLIiJ76sTABSps_f_4NzonB",
  showReclamation: window.SHOW_RECLAMATION ?? false,
  showTijaria: window.SHOW_TIJARIA ?? false,
  baseURL: window.API_URL ?? "http://localhost:8080/api",
  tijariaUrl: window.API_URL_TIJARIA ?? "https://chatbot-dev.portnet.ma",
};
export default config;
